<abp-modal [(visible)]="openAllocateModal" (disappear)="modalClose.emit(false)">
  <ng-template #abpHeader>
    <h3>
      {{ 'RegisterService::AllocateAssets' | abpLocalization }}
    </h3>
  </ng-template>
  <ng-template #abpBody>
    <app-locations-with-search
      [checkStrictly]="true"
      [checkable]="true"
      [readonly]="true"
      [restrictedKeys]="selectedLocation"
      (checkedKeysChange)="selectLocations($event)"
      [locationDefinition]="locationDefinition"
      [displayHeaders]="false"
      [withLookup]="true"
      [isGuest]="isGuest"
      [pinOrKeyringPassword]="pinOrKeyringPassword"
      [showTransferNotes]="!hasTransfer"
      [showSubAssetsNotes]="hasTransfer"
      [(subAssetsNotes)]="transferData.notes"
      [(transferNotes)]="notes"
    />
    <div class="flex gap-2" *ngIf="showMessage">
      <label class="text-black-base font-medium">
        {{ 'ServicingService::TotalSelected' | abpLocalization }}:
      </label>

      <label class="form-label"> {{ assets.length }} </label>
    </div>
  </ng-template>
  <ng-template #abpFooter>
    <button type="button" class="btn btn-primary" (click)="allocate()" [disabled]="isBusy">
      {{ 'AbpUi::Apply' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Close' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
